/*
 * Portal: the customer-facing layout
 */
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/barlow-semi-condensed/600.css';
import './styles/portal.css';
import sentryInit from './js/components/SentryInit';
import initFormBusyState from './js/general/FormBusyState';
// Stimulus and Turbo
import './bootstrap';
sentryInit();
initFormBusyState();
// iOS Safari only applies :active styles, our press feedback, once the page listens for touches
document.addEventListener('touchstart', () => { }, { passive: true });
